import script from "./allocationInWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./allocationInWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./allocationInWarehouse.vue?vue&type=style&index=0&id=2dbb9184&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dbb9184"]])

export default __exports__